<template>
    <!-- 企业注册 -->
    <div class="h-form-wrapper">
        <div class="h-form-box">
            <div class="ft-box">
                <div class="ft-title aFlex">
                    <Icon class="ft-title-mark" type="md-bookmark" />
                    <span>个人用户注册</span>
                </div>
            </div>
            <Form class="form-list" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row>
                    <Col span="12" offset="4">
                        <FormItem prop="mobile">
                            <div slot="label" style="display: inline-block">
                                <span>手机号码</span>
                                <div style="color: #ff3300">（登录用户名）</div>
                            </div>
                            <Input v-model="formInline.mobile" type="tel"  size="large" placeholder="请输入手机号码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="登录密码" prop="password">
                            <Input type="password" v-model="formInline.password" size="large" placeholder="请输入登录密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="确认密码" prop="passwdCheck">
                            <Input type="password" v-model="formInline.passwdCheck" size="large" placeholder="请输入确认密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="姓名" prop="name">
                            <Input v-model="formInline.name" size="large" placeholder="请输入姓名"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="身份证号" prop="idCardNumber">
                            <Input v-model="formInline.idCardNumber" type="tel"  size="large" placeholder="请输入身份证号"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <!--<Row>-->
                    <!--<Col span="12" offset="4">-->
                        <!--<FormItem label="短信验证码" prop="verifyNumber">-->
                            <!--<div class="aFlex">-->
                                <!--<Input v-model="formInline.verifyNumber" size="large" placeholder="请输入短信验证码"></Input>-->
                                <!--<Button style="margin-left: 15px" type="primary" size="large"-->
                                        <!--:disabled="timeing" @click="handleVerify">{{verifyTxt}}</Button>-->
                            <!--</div>-->
                        <!--</FormItem>-->
                    <!--</Col>-->
                <!--</Row>-->
                <Row>
                    <Col span="12" offset="4">
                        <FormItem>
                            <Button class="h-form-btn" type="primary" size="large" @click="handleSubmit('formInline')" :loading="loading">提交注册</Button>
                            <Button class="h-form-btn" size="large" @click="handleBack">返回</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    export default {
        data(){
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写手机号码!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkMobileExist',
                        params: {
                            mobile:value,
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('手机号已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            const validatePass = (rule, value, callback) => {
                let reg=/^.{6,18}$/;
                if (value === '') {
                    callback(new Error('请输入密码!'));
                } else {
                    if(reg.test(value)){
                        if (this.formInline.passwdCheck !== '') {
                            // 对第二个密码框单独验证
                            this.$refs.formInline.validateField('passwdCheck');
                        }
                        callback();
                    }else {
                        callback('密码必须6-18位');
                    }
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码!'));
                } else if (value !== this.formInline.password) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            };
            return {
                verifyTxt: '获取验证码',
                timeing: false,
                num:60,
                timeout:null,
                loading: false,
                formInline: {
                    mobile: '',
                    password: '',
                    passwdCheck: '',
                    name: '',
                    idCardNumber: '',
                    verifyNumber: '',
                    verifyCode: '',
                },
                ruleInline: {
                    password: [
                        { required: true,validator: validatePass, trigger: 'blur' }
                    ],
                    passwdCheck: [
                        { required: true, validator: validatePassCheck, trigger: 'blur' }
                    ],
                    name: [
                        { required: true, type:'string',  message: '姓名不能为空', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, type:'string',  message: '手机号码不能为空', trigger: 'blur' },
                        { pattern: /^1([3456789])\d{9}$/, message: '手机号不正确', trigger: 'change' },
                        { required: true, validator: validatePhone, trigger: 'blur' },
                    ],
                    idCardNumber: [
                        { required: true, type:'string',  message: '身份证号不能为空', trigger: 'blur' }
                    ],
                    verifyNumber: [
                        { required: true, type:'string',  message: '短信验证码不正确', trigger: 'submit' }
                    ],
                },
            };
        },
        computed:{
        },
        created(){
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            // 获取验证码
            handleVerify() {
                if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formInline.mobile)){
                    this.$Message.warning('手机号不正确');
                    return;
                }
                this.axios({
                    method: 'get',
                    url: '/register/getVerifyNumber',
                    params: {
                        mobile: this.formInline.mobile
                    },
                }).then((response) => {
                    if(response.data){
                        this.formInline.verifyCode = response.data;
                        this.timeing=true;
                        this.setTime();
                    }
                });
            },
            setTime(){
                if(this.num>0){
                    this.num--;
                    this.verifyTxt = '获取验证码( ' + this.num + ' )'
                }else{
                    clearTimeout(this.timeout);
                    this.num=60;
                    this.timeing=false;
                    this.verifyTxt = '重新获取';
                    return;
                }
                this.timeout=setTimeout(this.setTime,1000);
            },
            // 返回
            handleBack(){
                this.$router.go(-1);
            },
            // 提交
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={};
                        Object.assign(data,this.formInline);
                        delete data.passwdCheck;
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: '/register/registUser',
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Modal.success({
                                    title: '提示',
                                    content: '注册成功!',
                                    onOk:()=>{
                                        this.$router.go(-1);
                                    }
                                });
                            }else {
                                this.$Modal.warning({
                                    title: '提示',
                                    content: response.data.msg
                                });
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
